var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddTeamIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    "aria-hidden": "true",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1249 0.688252C22.3202 0.271748 19.3537 0 16 0C12.6463 0 9.6798 0.271748 7.87511 0.688252C4.27689 1.44332 1.44332 4.27689 0.688252 7.87511C0.271748 9.6798 0 12.6463 0 16C0 19.3537 0.271748 22.3202 0.688252 24.1249C1.44332 27.7231 4.27689 30.5567 7.87511 31.3117C9.6798 31.7283 12.6463 32 16 32C19.3537 32 22.3202 31.7283 24.1249 31.3117C27.7231 30.5567 30.5567 27.7231 31.3117 24.1249C31.7283 22.3202 32 19.3537 32 16C32 12.6463 31.7283 9.6798 31.3117 7.87511C30.5567 4.27689 27.7231 1.44332 24.1249 0.688252Z",
    fill: "#00B388"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 6C10.4764 6 6 10.4768 6 16C6 21.5236 10.4768 26 16 26C21.5236 26 26 21.5232 26 16C26 10.4764 21.5232 6 16 6ZM15.4995 11.0502V15.5H11.0498C10.3831 15.5 10.3831 16.5 11.0498 16.5H15.4995V20.9497C15.4995 21.6164 16.4995 21.6164 16.4995 20.9497V16.5H20.9493C21.6159 16.5 21.6159 15.5 20.9493 15.5H16.4995V11.0502C16.4995 10.3836 15.4995 10.3836 15.4995 11.0502Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddTeamIcon);
export default __webpack_public_path__ + "static/media/add_team_icon.599a3a40e994ed57e00b6afe6a1b39de.svg";
export { ForwardRef as ReactComponent };